export type CmpStripeConnectReadiness = {
  creditCardPaymentsReady?: boolean | null;
};

export const getCmpCreditCardPaymentsReady = (
  stripeConnect?: CmpStripeConnectReadiness | null
) => stripeConnect?.creditCardPaymentsReady === true;
